import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import useHistory from "routing/useHistory";
import Routes from "routing/Routes";
import { useErrorsContext } from "components/lookup-tables/contexts/ErrorsContext";
import ErrorPopover from "components/lookup-tables/ErrorPopover";
const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
const Title = styled.div`
  color: ${({ theme }) => theme.colors.link.default};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.link.hover};
    text-decoration: underline;
  }
`;
const TitleCol = ({ lut, children }) => {
  const { errors } = useErrorsContext();
  const tableErrorText = errors == null ? void 0 : errors.lutErrors[lut.name];
  const { push } = useHistory();
  const onClick = useCallback(() => {
    push(Routes.SYSTEM.LOOKUPTABLES.show(lut.name));
  }, [push, lut.name]);
  return /* @__PURE__ */ React.createElement(TitleRow, null, tableErrorText && /* @__PURE__ */ React.createElement(ErrorPopover, { placement: "right", errorText: tableErrorText, title: "Lookup Table problem" }), /* @__PURE__ */ React.createElement(Title, { onClick }, children));
};
const CacheCol = ({ cacheId, caches }) => {
  const { errors } = useErrorsContext();
  const { push } = useHistory();
  const onClick = useCallback(() => {
    var _a;
    push(Routes.SYSTEM.LOOKUPTABLES.CACHES.show((_a = caches == null ? void 0 : caches[cacheId]) == null ? void 0 : _a.name));
  }, [cacheId, caches, push]);
  if (!caches || !cacheId || !caches[cacheId]) return /* @__PURE__ */ React.createElement("i", null, "No cache");
  const cacheErrorText = errors == null ? void 0 : errors.cacheErrors[caches[cacheId].name];
  return /* @__PURE__ */ React.createElement(TitleRow, null, cacheErrorText && /* @__PURE__ */ React.createElement(ErrorPopover, { placement: "bottom", errorText: cacheErrorText, title: "Cache problem" }), /* @__PURE__ */ React.createElement(Title, { onClick }, caches[cacheId].title));
};
const DataAdapterCol = ({ dataAdapterId, dataAdapters }) => {
  const { errors } = useErrorsContext();
  const { push } = useHistory();
  const onClick = useCallback(() => {
    var _a;
    push(Routes.SYSTEM.LOOKUPTABLES.DATA_ADAPTERS.show((_a = dataAdapters == null ? void 0 : dataAdapters[dataAdapterId]) == null ? void 0 : _a.name));
  }, [dataAdapterId, dataAdapters, push]);
  if (!dataAdapters || !dataAdapterId || !dataAdapters[dataAdapterId]) return /* @__PURE__ */ React.createElement("i", null, "No data adapters");
  const adapterErrorText = errors == null ? void 0 : errors.adapterErrors[dataAdapters[dataAdapterId].name];
  return /* @__PURE__ */ React.createElement(TitleRow, null, adapterErrorText && /* @__PURE__ */ React.createElement(ErrorPopover, { placement: "bottom", errorText: adapterErrorText, title: "Data Adapter problem" }), /* @__PURE__ */ React.createElement(Title, { onClick }, dataAdapters[dataAdapterId].title));
};
const columnRenderers = {
  attributes: {
    title: {
      width: 0.1,
      renderCell: (title, lut) => /* @__PURE__ */ React.createElement(TitleCol, { lut }, title)
    },
    description: {
      width: 0.2,
      renderCell: (description) => /* @__PURE__ */ React.createElement("span", null, description)
    },
    name: {
      width: 0.1,
      renderCell: (name) => /* @__PURE__ */ React.createElement("span", null, name)
    },
    cache_id: {
      width: 0.1,
      renderCell: (cache_id, _c, meta) => /* @__PURE__ */ React.createElement(CacheCol, { cacheId: cache_id, caches: meta.caches })
    },
    data_adapter_id: {
      width: 0.1,
      renderCell: (data_adapter_id, _c, meta) => /* @__PURE__ */ React.createElement(DataAdapterCol, { dataAdapterId: data_adapter_id, dataAdapters: meta.adapters })
    }
  }
};
export default columnRenderers;
